import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 30 27" fill={color}>
    <g id="Session-Topics" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Product-Purchase-Guidance" transform="translate(-177.000000, -1083.000000)" stroke={color}>
        <g id="Stacked-Group" transform="translate(177.000000, 900.000000)">
          <g id="TV-Copy" transform="translate(0.000000, 183.000000)">
            <g id="Cal">
              <rect id="Rectangle-Copy-11" x="5.5" y="0.5" width="1" height="4" />
              <rect id="Rectangle-Copy-9" x="15" y="0.5" width="1" height="4" />
              <rect id="Rectangle-Copy-12" x="24.5" y="0.5" width="1" height="4" />
              <rect id="Rectangle" strokeWidth="0.75" x="0.375" y="2.375" width="29.25" height="24.25" />
              <rect id="Rectangle-Copy" strokeWidth="0.75" x="21.375" y="8.375" width="5.25" height="4.25" />
              <rect
                id="Rectangle-Copy-4"
                strokeWidth="0.75"
                fill={color}
                x="21.375"
                y="14.375"
                width="5.25"
                height="4.25"
              />
              <rect id="Rectangle-Copy-2" strokeWidth="0.75" x="12.375" y="8.375" width="5.25" height="4.25" />
              <rect id="Rectangle-Copy-5" strokeWidth="0.75" x="12.375" y="14.375" width="5.25" height="4.25" />
              <rect id="Rectangle-Copy-7" strokeWidth="0.75" x="12.375" y="20.375" width="5.25" height="4.25" />
              <rect id="Rectangle-Copy-3" strokeWidth="0.75" x="3.375" y="8.375" width="5.25" height="4.25" />
              <rect id="Rectangle-Copy-6" strokeWidth="0.75" x="3.375" y="14.375" width="5.25" height="4.25" />
              <rect id="Rectangle-Copy-8" strokeWidth="0.75" x="3.375" y="20.375" width="5.25" height="4.25" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/Cal.js